import React from 'react'

export const ProviderRegions: React.FC = () => {
  return <div />
}
